const actions = {
    OTP_CREATE_REQUEST: 'OTP_CREATE_REQUEST',
    OTP_CREATE_SUCCESS: 'OTP_CREATE_SUCCESS',
    OTP_CREATE_ERROR: 'OTP_CREATE_ERROR',

    createOtp: requestData => ({
        type: actions.OTP_CREATE_REQUEST,
        requestData,
    }),
};
export default actions;
